import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(() => ({
	Media: {
		height: '100%',
		width: '100%'
	},

	li: {
		lineHeight: '30px'
	},

	container: {
		display: 'flex',
		flexDirection: 'column',
		minHeight: '100vh',
		color: 'black'
	},

	mainWrapper: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center',
		alignItems: 'center',
		minHeight: 'calc(100vh - 50px)'
	},

	leftWrapper: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center',
		alignItems: 'center',
		minHeight: '100vh',
		width: '100%'
	},

	paperWrapper: {
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'center',
		alignItems: 'center',
		padding: '30px',
		width: '100%',
		height: '100%'
	},

	insideH1: {
		marginBottom: 15,
		fontWeight: '300',
		fontSize: '26px',
		lineHeight: '32px'
	},

	insideH4: {
		marginTop: 0,
		marginBottom: 20,
		fontWeight: '300',
		fontSize: '16px',
		lineHeight: '24px',
		letterSpacing: '0.15px'
	},

	logoImage: {
		height: '80px',
		margin: 0,
		padding: 0,
	},

	connectBox: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		alignItems: 'flex-start',
		gap: '16px',
		width: '480px'
	},

	connectionBox: {
		width: '480px',
		border: 'solid 1px #DBE5DE',
		borderRadius: '8px',
		padding: '16px'
	},

	iconConnection: {
		fontSize: '48px',
		color: '#006C50'
	},

	textBody: {
		fontSize: '16px',
		color: '#5C5F5D',
		textAlign: 'center',
		margin: '8px 0 0'
	},

	textFoot: {
		fontSize: '12px',
		color: '#5C5F5D',
		textAlign: 'left',
		margin: '0 0 12px'
	},

	textTitle: {
		fontSize: '16px',
		lineHeight: '24px',
		fontWeight: '500',
		margin: '16px 0 8px'
	},

	textSubTitle: {
		fontSize: '12px',
		fontWeight: '400',
		lineHeight: '20px',
		margin: 0
	},

	formTitle: {
		marginTop: 0,
		marginBottom: 0,
		width: '100%',
		fontWeight: '400',
		fontSize: '24px',
		lineHeight: '32px',
		color: "#002116 !important"
	},

	formSubTitle: {
		marginTop: 0,
		marginBottom: 5,
		width: '100%',
		fontWeight: '400',
		fontSize: '14px',
		lineHeight: '24px'
	},
}));

export { useStyles }
